export const bankAccount =
  'M287.966 52.782H28.7C12.883 52.782 0 65.663 0 81.5h316.67c0-15.828-12.875-28.7-28.703-28.7zM0 235.184c0 15.83 12.883 28.7 28.7 28.7h259.257c15.828 0 28.7-12.88 28.7-28.7V124.482H.006L0 235.183z'
